import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { NavLink } from 'react-router-dom';
import { Icon } from './ui';
import { mountLiquidLens } from './liquidLens';
import '../styles/liquid-navigation.css';

const entries = [
  ['/', 'house', '首頁'],
  ['/sets', 'layer-group', '卡組'],
  ['/add', 'plus', '新增'],
  ['/quiz', 'flask', '測驗'],
  ['/index', 'book-open', '索引'],
] as const;

export default function LiquidNavigation() {
  const nav = useRef<HTMLElement>(null);
  const canvas = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    if (nav.current && canvas.current) return mountLiquidLens(nav.current, canvas.current);
  }, []);
  return createPortal(
    <nav ref={nav} className="bottom-nav liquid-navigation" aria-label="主要導覽">
      <div className="liquid-nav-fallback" aria-hidden="true" />
      {entries.map(([path, icon, label]) => (
        <NavLink aria-label={label} end={path === '/'} key={path} to={path}
          className={path === '/add' ? 'nav-add' : ''}>
          <Icon name={icon} />
        </NavLink>
      ))}
      <canvas ref={canvas} className="liquid-nav-canvas" aria-hidden="true" />
    </nav>,
    document.body,
  );
}
